module.exports = __webpack_public_path__ + "d89f2ed23bcf4fb72515bc96c2d80135.svg";